import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

/** Contained brand button that fills with the brand's secondary (hover) color on hover. */
export const SecondaryHoverButton = styled(Button)(({ theme }) => ({
  '&:hover': { backgroundColor: theme.palette.secondary.main },
}));
